/**
 * Счётчик набора (ревью 2026-09-24): в набор приходит больше людей, чем мест в составе, —
 * лишние ждут следующего состава того же набора. Интерфейс не показывает «103 из 8»:
 * в составе не больше `size`, остальные — очередь.
 */
export interface PoolCount {
  /** Сколько показать в «N из size» — не больше размера состава */
  shown: number;
  /** Сколько ждут сверх полного состава */
  queue: number;
  /** Состав заполнен целиком */
  full: boolean;
}

export function poolCount(count: number, size: number): PoolCount {
  const safe = Math.max(0, count);
  return {
    shown: Math.min(safe, size),
    queue: Math.max(0, safe - size),
    full: size > 0 && safe >= size,
  };
}

/** Позиция в очереди попадает в первый состав набора — иначе ждёт следующего */
export function inFirstSquad(position: number, size: number): boolean {
  return position <= size;
}
